module.exports = __webpack_public_path__ + "static/media/6.388b08cd.JPG";